import styled from "styled-components";
import { FOOTER_FOREGROUND } from "../../templates/strings";
import { BADGE_ASPECT } from "./partnerBadgeLayout";

export const FooterContainer = styled.div`
  color: #000;
  font-size: 10px;
  padding-top: 20px;
  padding-bottom: 20px;
  outline: none;
  margin-top: 100px;
  margin-bottom: 30px;
  color: ${({ $footerForeground }) =>
    $footerForeground === FOOTER_FOREGROUND.SHADOWED
      ? "#fff"
      : $footerForeground};
  text-shadow: ${({ $footerForeground }) =>
    $footerForeground === FOOTER_FOREGROUND.SHADOWED
      ? "1px 0px 2px #5e5c5c"
      : "none"};
`;

export const CompanyDiv = styled.div`
  @media (max-width: 767px) {
    margin-bottom: 20px;
  }
`;

export const FooterImgDiv = styled.div`
  visibility: ${({ $shouldVisible }) =>
    $shouldVisible ? "visible" : "hidden"};
  @media (max-width: 767px) {
    margin-bottom: 50px;
  }
`;

export const FooterImg = styled.img`
  width: 200px;
  height: 100px;
`;

// Partner badge with the company logo (Asana 1213410886347834): same width
// as the uploaded partner logo, height from the badge's aspect ratio
export const BadgeContainer = styled.span`
  position: relative;
  display: inline-block;
  width: 200px;
  height: ${200 * BADGE_ASPECT}px;
  vertical-align: middle;
`;

export const BadgeImg = styled.img`
  display: block;
  width: 100%;
  height: 100%;
`;

export const BadgeLogoBox = styled.span`
  position: absolute;
  display: block;
`;

export const BadgeLogo = styled.img`
  display: block;
  width: 100%;
  height: 100%;
  object-fit: contain;
`;
